import React from 'react';
import ReactDOM from 'react-dom';
import Parts from "./Parts";

const fields = document.getElementsByTagName('input');
const checklistRegex = new RegExp(/\[parts\]/);
let points;
let pointsFieldName;

for (let i in fields) {
  if (checklistRegex.test(fields[i].name)) {
    points = fields[i].value;
    pointsFieldName = fields[i].name;
  }
}
let confParts = window.SPARE_PARTS;
if (points !== '') {
  points = JSON.parse(points);
} else {
  points = [];
}
ReactDOM.render(
  <Parts parts={points} confParts={confParts} fieldName={pointsFieldName} />,
  document.getElementById('parts-app')
);
